/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyForm } from '../models/company-form';


/**
 * API for managing company forms.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyFormsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listCompanyForms
   */
  static readonly ListCompanyFormsPath = '/company-forms';

  /**
   * Get list of company forms.
   *
   * Get list of company forms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCompanyForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCompanyForms$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<CompanyForm>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyFormsService.ListCompanyFormsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CompanyForm>>;
      })
    );
  }

  /**
   * Get list of company forms.
   *
   * Get list of company forms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listCompanyForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCompanyForms(params?: {
    context?: HttpContext
  }
): Observable<Array<CompanyForm>> {

    return this.listCompanyForms$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CompanyForm>>) => r.body as Array<CompanyForm>)
    );
  }

}
